"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DealPriceType;
(function (DealPriceType) {
    DealPriceType["FITTED"] = "Fitted";
    DealPriceType["PRIMARY"] = "RDP";
    DealPriceType["SECONDARY"] = "MLP";
    DealPriceType["VEHICLE_TOTAL"] = "TotalBalance";
    DealPriceType["FINAL_PRICE"] = "FinalPrice";
})(DealPriceType = exports.DealPriceType || (exports.DealPriceType = {}));
